import { Anchor, Group } from '@mantine/core';
import type { PropsWithChildren } from 'react';

import { useTranslation } from '@apple/lib/i18next';

export function AppleFooter({ children }: PropsWithChildren) {
	return (
		<Group justify='space-between' align='flex-end' w='100%'>
			<CopyrightLink />
			<Group>{children}</Group>
			<PrivacyLinks />
		</Group>
	);
}

const year = new Date().getFullYear();

function CopyrightLink() {
	const { t } = useTranslation('common');
	return (
		<Anchor href='https://arvato.com' c='dimmed' size='xxs'>
			{t('shell.copyright', { year })}
		</Anchor>
	);
}

function PrivacyLinks() {
	const { t } = useTranslation('common');

	return (
		<Anchor
			href='https://arvato.com/arvato-us-privacy-policy-applications'
			target='_blank'
			size='xxs'
		>
			{t('shell.privacyStatement')}
		</Anchor>
	);
}
